import { createApp } from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import ContactAdvisorBlock from './ContactAdvisorBlock'

const el = ".nyk-component--contact-advisor";

export default function () {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach(async (ContactAdvisorBlockDOM) => {
            const apiPath = ContactAdvisorBlockDOM.getAttribute('data-api-path')
            const recaptchaSiteKey = ContactAdvisorBlockDOM.getAttribute('data-recaptcha-site-key')
            const antiForgeryToken = ContactAdvisorBlockDOM.getAttribute('data-anti-forgery-token')
            const labelsString = ContactAdvisorBlockDOM.getAttribute('data-labels')
            const labels = labelsString ? JSON.parse(decodeURIComponent(labelsString)) : {};
            const allowInternationalNumber = ContactAdvisorBlockDOM.getAttribute('data-allow-international-number') === 'true'

            const component = createApp(ContactAdvisorBlock, {
                apiPath,
                antiForgeryToken,
                labels,
                allowInternationalNumber
            })
            component.use(VueReCaptcha, { siteKey: recaptchaSiteKey })
            component.mount(ContactAdvisorBlockDOM)
        })
    }
}

